var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCliente
    ? _c("ClienteSidebar", {
        attrs: { collapsed: _vm.collapsed, mobile: _vm.mobile, open: _vm.open },
        on: {
          toggle: _vm.toggle,
          select: _vm.onSelect,
          back: _vm.onBack,
          picked: _vm.onPicked,
          "open-all": _vm.onOpenAll
        }
      })
    : _c("GestaoSidebar", {
        attrs: { collapsed: _vm.collapsed, mobile: _vm.mobile, open: _vm.open },
        on: {
          toggle: _vm.toggle,
          select: _vm.onSelect,
          "enter-clientes": _vm.onEnterClientes
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }